module.exports = "<my-train-display my-train=\"$$train.data.myTrain\"\n  my-wagons=\"$$wagon.data.myWagons\"\n  enable-buttons=\"true\"\n  enable-title=\"true\"\n  enable-back=\"true\">\n</my-train-display>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/train/templates/details.html
// module id = 1527
// module chunks = 0